export default __webpack_public_path__ + "img/e34c8f341675689c7fcc06b8cb17c815.svg";